import React from 'react';
import { createPortal } from 'react-dom';
import Points from 'components/Points';
import { AssetUrls } from 'config/assets';
import './OfferPhoneCartBar.css';

interface OfferPhoneCartBarProps {
  /** Lines in this side's cart. */
  count: number;
  /** "They send" or "You send". */
  label: string;
  totalPoints: number;
  onOpen: () => void;
  /** Active filter count for the Filters badge. */
  filtersCount: number;
  onOpenFilters: () => void;
}

/**
 * The phone cart bar (Asana 1219788320590626 Decision 14): the OfferColumn
 * collapses into a 56px bar that owns the bottom edge and carries the
 * Filters button, following the profile Want List rule (no filter dock while
 * a cart bar is shown). Portalled to body: fixed descendants inside the app
 * shell's overflow:hidden wrapper are clipped.
 */
export const OfferPhoneCartBar: React.FC<OfferPhoneCartBarProps> = ({
  count,
  label,
  totalPoints,
  onOpen,
  filtersCount,
  onOpenFilters,
}) =>
  createPortal(
    <div className="offer-phone-bar" data-testid="offer-phone-bar">
      <button
        type="button"
        className="offer-phone-bar-main"
        onClick={onOpen}
        aria-label={`${label}: ${count} ${count === 1 ? 'card' : 'cards'}. Open your offer`}
      >
        <span className="offer-phone-bar-count" data-testid="offer-phone-bar-count">
          {count}
        </span>
        <span className="offer-phone-bar-label">{label}</span>
        <Points type="small" points={totalPoints} />
        <img className="offer-phone-bar-caret" src={AssetUrls.icons.dropdowns.arrowUp} alt="" aria-hidden="true" />
      </button>
      <button
        type="button"
        className="offer-phone-bar-filters"
        onClick={onOpenFilters}
        aria-label={filtersCount > 0 ? `Filters, ${filtersCount} active` : 'Filters'}
        data-testid="offer-phone-bar-filters"
      >
        Filters
        {filtersCount > 0 && <span className="offer-phone-bar-filters-badge">{filtersCount}</span>}
      </button>
    </div>,
    document.body,
  );

export default OfferPhoneCartBar;
